/**
 * Cookie management utilities for kiosk device authentication
 * Cookies persist better than localStorage across browser restarts
 */

export const CookieUtils = {
  /**
   * Set a cookie with secure options
   * For kiosk devices, we use long-lived cookies that persist across restarts
   */
  setCookie(name: string, value: string, days: number = 365): void {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);

    // Set cookie with all security options appropriate for the environment
    const isSecure = window.location.protocol === 'https:';
    const cookieString = `${name}=${encodeURIComponent(value)}; expires=${expires.toUTCString()}; path=/; SameSite=Strict${isSecure ? '; Secure' : ''}`;

    document.cookie = cookieString;
    console.log(`[Cookies] Set cookie: ${name}`);
  },

  /**
   * Get a cookie value by name
   */
  getCookie(name: string): string | null {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');

    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) {
        const value = decodeURIComponent(c.substring(nameEQ.length, c.length));
        return value;
      }
    }

    return null;
  },

  /**
   * Delete a cookie by setting it to expire immediately
   */
  deleteCookie(name: string): void {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    console.log(`[Cookies] Deleted cookie: ${name}`);
  },

  /**
   * Check if a cookie exists
   */
  hasCookie(name: string): boolean {
    return this.getCookie(name) !== null;
  }
};

// Kiosk-specific cookie names
export const KIOSK_COOKIES = {
  DEVICE_TOKEN: 'kiosk_device_token',
  DEVICE_ID: 'kiosk_device_id',
  DEVICE_NAME: 'kiosk_device_name',
  PAIRED_AT: 'kiosk_paired_at'
} as const;
